import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=364fc734&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=364fc734&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364fc734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364fc734')) {
      api.createRecord('364fc734', component.options)
    } else {
      api.reload('364fc734', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=364fc734&scoped=true", function () {
      api.rerender('364fc734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/investment-stategy-manager/Modal.vue"
export default component.exports